/** O que `noPrazo` devolve quando a promessa não terminou a tempo. */
export const ESGOTADO = Symbol('prazo esgotado');

/**
 * A promessa, ou `ESGOTADO` se ela não terminar em `ms` (Fase 43, RN-619).
 *
 * Ela continua correndo: no sinal fraco a rede não cai e não chega, e quem espera é a tela, que não
 * pode ficar presa. Quem chama decide o que fazer com o resultado que chegar depois.
 */
export function noPrazo<T>(promessa: Promise<T>, ms: number): Promise<T | typeof ESGOTADO> {
  let relogio: ReturnType<typeof setTimeout> | undefined;
  const esgotou = new Promise<typeof ESGOTADO>((resolve) => {
    relogio = setTimeout(() => resolve(ESGOTADO), ms);
  });
  return Promise.race([promessa, esgotou]).finally(() => clearTimeout(relogio));
}
